
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

function EmailForm() {
  const [submitted, setSubmitted] = useState(false);

  // Define the checkMandatory function
  function checkMandatory() {
    const mandatoryFields = ['Last Name', 'Email'];
    let allFieldsValid = true;

    mandatoryFields.forEach((field) => {
      const fieldElement = document.getElementById(field.replace(" ", "_"));
      if (fieldElement && fieldElement.value.trim() === '') {
        alert(`${field} cannot be empty`);
        fieldElement.focus();
        allFieldsValid = false;
      }
    });

    return allFieldsValid;
  }


  function validateEmail() {
    const emailFld = document.querySelectorAll('[ftype=email]');
    let isValid = true;

    emailFld.forEach((field) => {
      const emailVal = field.value.trim();
      if (emailVal.length !== 0) {
        const atpos = emailVal.indexOf('@');
        const dotpos = emailVal.lastIndexOf('.');
        if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
          alert('Please enter a valid email address.');
          field.focus();
          isValid = false;
        }
      }
    });

    return isValid;
  }

    async function handleSubmit(e) {
    e.preventDefault();

    const isMandatory = checkMandatory();
    if (!isMandatory) return;

    const form = document.getElementById('webformtoemail2026');

    const payload = {
      firstName: form.First_Name.value,
      lastName: form.Last_Name.value,
      email: form.Email.value,
      phone: form.Phone.value,
      message: form.Description.value,
      company: form.Company.value
    };

    const API = process.env.REACT_APP_API_URL || "";

    try {

      const response = await fetch(`${API}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error();

      const splashinfodom = document.getElementById('wf_splash_info');
      if (splashinfodom) {
        splashinfodom.innerText = 'Thanks! Your message has been sent.';
      }

      document.getElementById('webformtoemail2026').reset();

      document
        .querySelector('.crmWebToEntityForm .formsubmit')
        .removeAttribute('disabled');

      setSubmitted(true);

    } catch (error) {

      alert('An error occurred sending your message.');

    }
  }

  return (
    <div id="crmWebToEntityForm" className="zcwf_lblLeft crmWebToEntityForm" style={{ maxWidth: '600px' }}>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="content-type" content="text/html;charset=UTF-8" />

      {submitted ? (
        <div className="wf_customMessageBox" style={{ display: 'block' }}>
          <div className="wf_customCircle">
            <div className="wf_customCheckMark"></div>
          </div>
          <span id="wf_splash_info">Thanks! Your message has been sent.</span>
        </div>
      ) : (
        <form id="webformtoemail2026" name="WebToEmail" acceptCharset="UTF-8" onSubmit={handleSubmit}>
          <input
            type="text"
            id="Company"
            name="Company"
            style={{ display: "none" }}
            tabIndex="-1"
            autoComplete="off"
          />

          {/* <div className="zcwf_title" style={{ maxWidth: '600px', color: 'black', fontFamily: 'Arial' }}>Basic Message Form</div> */}

          <div className="zcwf_row">
            <div className="zcwf_col_lab" style={{ fontSize: '12px', fontFamily: 'Arial' }}>
              <label htmlFor="First_Name">First Name</label>
            </div>
            <div className="zcwf_col_fld">
              <input type="text" id="First_Name" name="First Name" aria-required="false" aria-label="First Name" maxLength="40" />
            </div>
          </div>

          <div className="zcwf_row">
            <div className="zcwf_col_lab" style={{ fontSize: '12px', fontFamily: 'Arial' }}>
              <label htmlFor="Last_Name">Last Name<span style={{ color: 'red' }}>*</span></label>
            </div>
            <div className="zcwf_col_fld">
              <input type="text" id="Last_Name" name="Last Name" aria-required="true" aria-label="Last Name" maxLength="80" />
            </div>
          </div>

          <div className="zcwf_row">
            <div className="zcwf_col_lab" style={{ fontSize: '12px', fontFamily: 'Arial' }}>
              <label htmlFor="Phone">Phone</label>
            </div>
            <div className="zcwf_col_fld">
              <input type="text" id="Phone" name="Phone" aria-required="false" aria-label="Phone" maxLength="30" />
            </div>
          </div>

          <div className="zcwf_row">
            <div className="zcwf_col_lab" style={{ fontSize: '12px', fontFamily: 'Arial' }}>
              <label htmlFor="Email">Email<span style={{ color: 'red' }}>*</span></label>
            </div>
            <div className="zcwf_col_fld">
              <input type="email" id="Email" name="Email" aria-required="true" aria-label="Email" maxLength="100" />
            </div>
          </div>

          <div className="zcwf_row">
            <div className="zcwf_col_lab" style={{ fontSize: '12px', fontFamily: 'Arial' }}>
              <label htmlFor="Description">Message</label>
            </div>
            <div className="zcwf_col_fld">
              <textarea id="Description" name="Description" aria-required="false" aria-label="Description"></textarea>
            </div>
          </div>

          <div className="zcwf_row">
            <div className="zcwf_col_fld">
              <input
                type="submit"
                id="formsubmit"
                className="formsubmit zcwf_button"
                value="Submit"
                aria-label="Submit"
                title="Submit"
              /> &nbsp;
              <input
                type="reset"
                className="zcwf_button"
                value="Reset"
                aria-label="Reset"
                title="Reset"
              />
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default EmailForm
